import { stringify } from 'qs';
import request from '../request';
import { url } from '../service-utils';

/**
 * 我发布的列表
 * 陈陈
 * @param {number} page
 * @param {number} pageSize
 */
export async function getList(payload) {
  const params = { ...payload };
  return request(`${url.meetingSign}/meeting/info/meetingAdminList?${stringify(params)}`);
}


/**
 * 发布会议
 * 陈陈
 * @param {string} meetinginfoid
 */
export async function pushMeeting(payload) {
  const params = { ...payload };
  return request(`${url.meetingSign}/meeting/info/publish?${stringify(params)}`);
}

/**
 * 删除会议
 * 陈陈
 * @param {string} meetinginfoid
 */
export async function delMeeting(payload) {
  const params = { ...payload };
  return request(`${url.meetingSign}/meeting/info/delete?${stringify(params)}`);
}